import { _ } from '@ngx-translate/core';

export const DIALOG_EVENT_MAX_COMMENT_LENGTH = 1000;

export interface IDialogEventCommentWording {
  label: string;
  placeholder: string;
  requiredError: string;
}

export const DIALOG_EVENT_COMMENT_WORDING: IDialogEventCommentWording = {
  label: _(`@@shared-comment-label`),
  placeholder: _(`@@edit-comment-placeholder`),
  requiredError: _(`@@fp-event-validation__comment`),
};

/** for a change that has to be justified — the note is asked for as its reason */
export const DIALOG_EVENT_REASON_WORDING: IDialogEventCommentWording = {
  label: _(`@@fp-event-status-form__reason`),
  placeholder: _(`@@fp-event-status-form__reason-placeholder`),
  requiredError: _(`@@fp-event-validation__reason`),
};
